module.exports = __webpack_public_path__ + "media/images/icons/phone-ea466002f36bf8db420ddcde64eb482a.svg";